module.exports = __webpack_public_path__ + "static/media/team-users.cb8ff69e.svg";